import api from './api';
import { apiPath } from '../config/apiConfig';
import { AppInstance, CreateInstanceRequest, UpdateInstanceRequest, ApiResponse } from '../types';

export const instancesAPI = {
  // Create new instance
  createInstance: async (instanceData: CreateInstanceRequest): Promise<AppInstance> => {
    const response = await api.post<ApiResponse<AppInstance>>(apiPath('/instances'), instanceData);
    return response.data.data!;
  },

  // Get instances for an application
  getInstancesByApplication: async (applicationId: string): Promise<AppInstance[]> => {
    const response = await api.get<ApiResponse<AppInstance[]>>(
      apiPath(`/instances/application/${applicationId}`)
    );
    return response.data.data!;
  },

  /** One request for all instances on the listed applications (server-side join). */
  getInstancesByApplicationIdsBulk: async (applicationIds: string[]): Promise<AppInstance[]> => {
    if (!applicationIds.length) return [];
    const response = await api.post<ApiResponse<AppInstance[]>>(
      apiPath('/instances/bulk-by-applications'),
      { applicationIds }
    );
    return response.data.data ?? [];
  },

  // Update instance
  updateInstance: async (instanceId: string, updateData: UpdateInstanceRequest): Promise<AppInstance> => {
    const response = await api.put<ApiResponse<AppInstance>>(apiPath(`/instances/${instanceId}`), updateData);
    return response.data.data!;
  },

  // Delete instance
  deleteInstance: async (instanceId: string): Promise<void> => {
    await api.delete<ApiResponse<void>>(apiPath(`/instances/${instanceId}`));
  }
};

